<template>
  <div>
    <!-- 列表页面 -->

    <div class="page-container" v-if="showEdit == 0">
      <!-- 查询条件 -->
      <div class="search-section">
        <el-form :inline="true" :model="queryForm" class="demo-form-inline">
          <el-form-item label="日志日期" prop="daily_date">
            <el-date-picker
              v-model="queryForm.daily_date"
              type="date"
              placeholder="输入日期"
              size="default"
              value-format="YYYY-MM-DD"
            />
          </el-form-item>

          <el-form-item label="填写人" prop="create_user_id">
            <el-select
              v-model="queryForm.create_user_id"
              placeholder="请选择用户"
              clearable
              filterable
              @change="handleUserChange"
            >
              <el-option v-for="item in userList" :key="item.id" :label="item.nickname" :value="item.id" />
            </el-select>
          </el-form-item>

          <el-form-item label="所属项目" prop="project_id">
            <el-select v-model="queryForm.project_id" placeholder="所属项目" clearable filterable>
              <el-option v-for="item in projectInfoArr" :key="item.id" :label="item.project_name" :value="item.id" />
            </el-select>
          </el-form-item>

          <el-form-item label="关键字">
            <el-input v-model="queryForm.keyword" placeholder="日志内容/备注" clearable />
          </el-form-item>

          <el-form-item label="日志类型">
            <el-select v-model="queryForm.daily_type" placeholder="日志类型" clearable filterable>
              <el-option v-for="item in dailyTypeArr" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>

          <el-form-item label="日志状态">
            <el-select v-model="queryForm.daily_status" placeholder="日志状态" clearable filterable>
              <el-option v-for="item in dailyStatusArr" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>

          <el-form-item label="提交状态">
            <el-select v-model="queryForm.is_commit" placeholder="提交状态" clearable filterable>
              <el-option v-for="item in dailyCommitArr" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>

          <el-form-item label="确认状态">
            <el-select v-model="queryForm.is_confirm" placeholder="确认状态" clearable filterable>
              <el-option v-for="item in dailyConfirmArr" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>

          <el-form-item style="width: auto">
            <el-button type="primary" @click="search">查询</el-button>
            <!-- <el-button type="primary" @click="add">新增</el-button> -->
            <!-- <el-button type="primary" @click="addBatch">批量新增</el-button> -->
            <el-tooltip effect="dark" content="会根据当前日志日期，填写人确认数据">
              <!-- <el-button type="primary" @click="handlerConfirmBatch">日志确认</el-button> -->
              <el-button type="primary" @click="handlerConfirmBatch2">日志确认</el-button>
            </el-tooltip>

            <el-tooltip effect="dark" content="会根据当前日志日期，填写人，将已确认数据设置为未确认">
              <el-button type="primary" @click="handlerUnConfirmBatch">日志未确认</el-button>
            </el-tooltip>
          </el-form-item>
        </el-form>
      </div>
      <!-- 表格 -->
      <div class="table-section">
        <el-table :data="tableData" v-loading="loading" style="width: 100%" fit :row-class-name="rowClassName">
          <el-table-column type="index" :index="indexMethod" label="序号" fixed="left" width="60px"></el-table-column>

          <el-table-column prop="daily_date" label="日期" min-width="120px">
            <template #default="scope">
              {{ formatDate(scope.row.daily_date) }}
            </template>
          </el-table-column>
          <el-table-column prop="create_user_name" label="填写人" min-width="100px" width=""></el-table-column>

          <el-table-column prop="daily_type_name" label="日志类型" min-width="120px" width=""></el-table-column>
          <el-table-column prop="project_name2" label="所属项目" min-width="120px" width=""></el-table-column>
          <!-- <el-table-column prop="task_name" label="任务" min-width="120px"></el-table-column> -->
          <el-table-column prop="daily_status_name" label="状态" min-width="120px" width=""></el-table-column>
          <el-table-column prop="daily_content" label="日志内容" min-width="180px" width=""></el-table-column>
          <el-table-column prop="estimated_hours" label="计划用时" min-width="100px" width=""></el-table-column>
          <el-table-column prop="actual_hours" label="实际用时" min-width="100px" width=""></el-table-column>

          <el-table-column prop="daily_commit_name" label="提交状态" min-width="120px" width=""></el-table-column>
          <el-table-column prop="daily_confirm_name" label="确认状态" min-width="120px" width=""></el-table-column>
          <el-table-column prop="confirm_content" label="确认意见" min-width="120px" width=""></el-table-column>
          <el-table-column prop="remark" label="备注" min-width="100px" width=""></el-table-column>

          <el-table-column label="操作栏" fixed="right" width="180px">
            <template #default="scope">
              <!-- <el-button type="text" :disabled="scope.row.is_confirm==1" size="small" round @click="handleConfirm(scope.row)">确认</el-button> -->
              <el-button
                type="text"
                :disabled="scope.row.is_commit == 0 || scope.row.is_confirm != 0"
                size="small"
                round
                @click="handleConfirm2(scope.row)"
                >确认</el-button
              >
              <el-button
                type="text"
                :disabled="scope.row.is_confirm != 1"
                size="small"
                round
                @click="handleUnConfirm(scope.row)"
                >未确认</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <div class="demo-pagination-block">
          <!-- <div class="demonstration">All combined</div> -->
          <el-pagination
            v-model:current-page="currentPage"
            v-model:page-size="pageSize"
            :page-sizes="[10, 20, 30]"
            :small="small"
            :disabled="disabled"
            :background="background"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalSize"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>

    <!-- 编辑页面 -->
    <diary-add v-if="showEdit == 1" @editClose="editClose" :editId="editDiaryId"></diary-add>

    <diary-add-batch v-if="showEdit == 2" @editClose="editClose"></diary-add-batch>

    <el-dialog v-model="dialogConfirm" title="日志确认">
      <el-form :model="confirmForm">
        <el-form-item label="回复内容" :label-width="formLabelWidth">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 8 }"
            placeholder="请输入确认内容"
            v-model="confirmForm.confirm_content"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="handlerConfirmCancel">取消</el-button>
          <el-button type="primary" @click="handlerConfirm"> 通过 </el-button>
          <el-button type="primary" @click="handlerConfirmNo"> 不通过 </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, reactive, onMounted } from 'vue'
import { ElMessageBox, ElMessage } from 'element-plus'
import projectInfo from '@/model/projectInfo'
import projectDaily from '@/model/projectDaily'
import sysDictItemModel from '@/model/sysDictItem'
import DiaryAdd from './diary-add'
import DiaryAddBatch from './diary-add-batch'

export default {
  components: {
    DiaryAdd,
    DiaryAddBatch,
  },

  setup() {
    const editDiaryId = ref(1)
    const showEdit = ref(0)

    const loading = ref(false)

    const currentPage = ref(1)
    const pageSize = ref(10)
    const totalSize = ref(100)

    const dailyTypeArr = ref([])
    const dailyStatusArr = ref([])
    const projectInfoArr = ref([])
    const dailyCommitArr = ref([])
    const dailyConfirmArr = ref([])
    const userList = ref([])

    const dialogConfirm = ref(false)
    const formLabelWidth = '140px'

    const confirmForm = reactive({
      id: '',
      is_confirm: '',
      confirm_content: '',
    })

    const queryForm = reactive({
      keyword: '',
      daily_type: '',
      daily_status: '',
      daily_date: getDefaultDate(),
      project_id: '',
      is_commit: '',
      is_confirm: '',
      create_user_id: '',
      create_user_name: '',
      page: 1,
      count: 10,
    })

    const resultPage = ref({})

    const tableData = ref([])

    onMounted(() => {
      // 列出所有项目信息
      getDiaryPage()
      loadDictDitems()
    })

    const getDiaryPage = async () => {
      try {
        queryForm.page = currentPage.value
        queryForm.count = pageSize.value

        loading.value = true
        resultPage.value = await projectDaily.getProjectDailyPage(queryForm)
        tableData.value = resultPage.value.items

        totalSize.value = resultPage.value.total

        currentPage.value = resultPage.value.page
        pageSize.value = resultPage.value.count

        loading.value = false
      } catch (error) {
        loading.value = false
        if (error.code === 10020) {
          tableData.value = []
        }
      }
    }

    const search = () => {
      getDiaryPage()
    }

    // 根据字典类型查询字典
    const loadDictDitems = async () => {
      dailyTypeArr.value = await sysDictItemModel.getSysDictItemListByType('daily_type')
      dailyStatusArr.value = await sysDictItemModel.getSysDictItemListByType('daily_status')
      projectInfoArr.value = await projectInfo.getProjectInfoList('')
      dailyCommitArr.value = await sysDictItemModel.getSysDictItemListByType('daily_commit')
      dailyConfirmArr.value = await sysDictItemModel.getSysDictItemListByType('daily_confirm')

      // 这里加个所有人选项
      userList.value = await projectDaily.getAllUsers()
      const allUser = { id: -1, username: 'all', nickname: '所有人', avatar: null, email: '' }
      userList.value.unshift(allUser)
      // console.log(userList.value)
    }

    const handleEdit = row => {
      // 编辑操作
      editDiaryId.value = row.id
      showEdit.value = 1
    }

    const handleDelete = row => {
      // 删除操作
      ElMessageBox.confirm('此操作将永久删除该日志, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await projectDaily.deleteProjectDaily(row.id)
          if (res.code < window.MAX_SUCCESS_CODE) {
            getDiaryPage()
            ElMessage.success(`${res.message}`)
          }
        })
        .catch(() => {
          // 用户点击取消按钮时执行的操作
          // 可以选择不做任何事情，也可以显示取消消息
          // ElMessage.info('操作已取消'); // 如果需要显示取消消息，可以取消注释
        })
    }

    // 提交
    const handleCommit = row => {
      ElMessageBox.confirm('此操作将提交该日志, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await projectDaily.commitProjectDaily(row.id)
          if (res.code < window.MAX_SUCCESS_CODE) {
            getDiaryPage()
            ElMessage.success(`${res.message}`)
          }
        })
        .catch(() => {
          // 用户点击取消按钮时执行的操作
          // 可以选择不做任何事情，也可以显示取消消息
          // ElMessage.info('操作已取消'); // 如果需要显示取消消息，可以取消注释
        })
    }

    // 确认
    const handleConfirm = row => {
      ElMessageBox.confirm('此操作将确认该日志, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await projectDaily.confirmProjectDaily(row.id)
          if (res.code < window.MAX_SUCCESS_CODE) {
            getDiaryPage()
            ElMessage.success(`${res.message}`)
          }
        })
        .catch(() => {
          // 用户点击取消按钮时执行的操作
          // 可以选择不做任何事情，也可以显示取消消息
          // ElMessage.info('操作已取消'); // 如果需要显示取消消息，可以取消注释
        })
    }

    // 确认
    const handleConfirm2 = row => {
      confirmForm.id = row.id

      dialogConfirm.value = true
    }

    // 未确认

    const handleUnConfirm = row => {
      ElMessageBox.confirm('此操作将该日志改为未确认, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await projectDaily.unConfirmProjectDaily(row.id)
          if (res.code < window.MAX_SUCCESS_CODE) {
            getDiaryPage()
            ElMessage.success(`${res.message}`)
          }
        })
        .catch(() => {
          // 用户点击取消按钮时执行的操作
          // 可以选择不做任何事情，也可以显示取消消息
          // ElMessage.info('操作已取消'); // 如果需要显示取消消息，可以取消注释
        })
    }

    const handleSizeChange = val => {
      pageSize.value = val
      getDiaryPage()
    }

    const handleCurrentChange = val => {
      currentPage.value = val
      getDiaryPage()
    }

    const indexMethod = index => (currentPage.value - 1) * pageSize.value + index + 1

    // 子控部分

    const add = () => {
      showEdit.value = 1
      editDiaryId.value = ''
    }

    const addBatch = () => {
      showEdit.value = 2
      editDiaryId.value = ''
    }

    const editClose = () => {
      showEdit.value = 0
      getDiaryPage()
    }

    const formatDate = date_str => {
      if (date_str) {
        return date_str.match(/\d{4}-\d{2}-\d{2}/)[0] // 获取年月日部分
      }
      return date_str
    }

    const handleUserChange = () => {
      const selectedUser = userList.value.find(user => user.id === queryForm.create_user_id)
      queryForm.create_user_name = selectedUser.nickname
    }

    const handlerConfirmBatch = () => {
      try {
        if (!queryForm.daily_date) {
          ElMessage.error('日志日期不能为空！')
          return
        }

        if (!queryForm.create_user_id) {
          ElMessage.error('填写人不能为空！')
          return
        }

        // todo  这里获取当前userList的select 的内容

        // 确认操作
        ElMessageBox.confirm(
          `确认（${queryForm.create_user_name}）~（${queryForm.daily_date}）日志, 是否继续?`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          },
        )
          .then(async () => {
            const info = { daily_date: queryForm.daily_date, create_user_id: queryForm.create_user_id }

            // let res =await projectDaily.confirmBatchProjectDaily(info)
            const res = await projectDaily.confrimBatch(info)

            if (res.code < window.MAX_SUCCESS_CODE) {
              getDiaryPage()
              ElMessage.success(`${res.message}`)
            }
          })
          .catch(() => {
            // 用户点击取消按钮时执行的操作
            // 可以选择不做任何事情，也可以显示取消消息
            // ElMessage.info('操作已取消'); // 如果需要显示取消消息，可以取消注释
          })
      } catch (error) {
        if (error.code === 10020) {
          ElMessage.error('请填写确认有提交日志')
        }
      }
    }

    const handlerConfirmBatch2 = () => {
      if (!queryForm.daily_date) {
        ElMessage.error('日志日期不能为空！')
        return
      }

      if (!queryForm.create_user_id) {
        ElMessage.error('填写人不能为空！')
        return
      }
      confirmForm.confirm_content = ''
      confirmForm.is_confirm = 0
      confirmForm.id = ''
      dialogConfirm.value = true
    }

    const handlerConfirmCancel = () => {
      confirmForm.confirm_content = ''
      confirmForm.is_commit = 0
      dialogConfirm.value = false
    }

    const handlerConfirm = () => {
      try {
        confirmForm.is_confirm = 1
        let message = ''
        debugger
        if (confirmForm.id) {
          // 走单条的逻辑
          message = '确认当前的日志, 是否继续?'
          // alert("走单条的逻辑")
        } else {
          // 走批量的逻辑
          message = `确认（${queryForm.create_user_name}）~（${queryForm.daily_date}）日志, 是否继续?`
          // alert("走批量的逻辑")
        }
        debugger
        ElMessageBox.confirm(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res

            if (confirmForm.id) {
              // 单挑记录的确认
              const info = {
                id: confirmForm.id,
                is_confirm: confirmForm.is_confirm,
                confirm_content: confirmForm.confirm_content,
              }
              res = await projectDaily.confirmProjectDaily(confirmForm.id, info)
            } else {
              // 批量数据的确认
              const info = {
                daily_date: queryForm.daily_date,
                create_user_id: queryForm.create_user_id,
                is_confirm: confirmForm.is_confirm,
                confirm_content: confirmForm.confirm_content,
              }
              res = await projectDaily.confrimBatch(info)
            }

            if (res.code < window.MAX_SUCCESS_CODE) {
              getDiaryPage()
              // 设置为确认，内容可以为空
              dialogConfirm.value = false
              ElMessage.success(`${res.message}`)
            }
          })
          .catch(() => {
            // 用户点击取消按钮时执行的操作
            // 可以选择不做任何事情，也可以显示取消消息
            // ElMessage.info('操作已取消'); // 如果需要显示取消消息，可以取消注释
          })
      } catch (error) {
        if (error.code === 10020) {
          ElMessage.error('请填写确认有提交日志')
        }
      }
    }

    const handlerConfirmNo = () => {
      try {
        if (!confirmForm.confirm_content) {
          ElMessage.error('请输入不通过的理由！')
          return
        }
        confirmForm.is_confirm = 2

        let message = ''
        if (confirmForm.id) {
          // 走单条的逻辑
          message = '确认当前的日志为不通过, 是否继续?'
          // alert("走单条的逻辑")
        } else {
          // 走批量的逻辑
          message = `确认（${queryForm.create_user_name}）~（${queryForm.daily_date}）日志为不通过, 是否继续?`
          // alert("走批量的逻辑")
        }

        ElMessageBox.confirm(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res

            if (confirmForm.id) {
              // 单挑记录的确认
              const info = {
                id: confirmForm.id,
                is_confirm: confirmForm.is_confirm,
                confirm_content: confirmForm.confirm_content,
              }
              res = await projectDaily.confirmProjectDaily(confirmForm.id, info)
            } else {
              // 批量数据的确认
              const info = {
                daily_date: queryForm.daily_date,
                create_user_id: queryForm.create_user_id,
                is_confirm: confirmForm.is_confirm,
                confirm_content: confirmForm.confirm_content,
              }
              res = await projectDaily.confrimBatch(info)
            }

            if (res.code < window.MAX_SUCCESS_CODE) {
              getDiaryPage()
              // 设置为确认，内容可以为空
              dialogConfirm.value = false
              ElMessage.success(`${res.message}`)
            }
          })
          .catch(() => {
            // 用户点击取消按钮时执行的操作
            // 可以选择不做任何事情，也可以显示取消消息
            // ElMessage.info('操作已取消'); // 如果需要显示取消消息，可以取消注释
          })
      } catch (error) {
        if (error.code === 10020) {
          ElMessage.error('请填写确认有提交日志')
        }
      }
    }

    const handlerUnConfirmBatch = () => {
      try {
        if (!queryForm.daily_date) {
          ElMessage.error('日志日期不能为空！')
          return
        }

        if (!queryForm.create_user_id) {
          ElMessage.error('填写人不能为空！')
          return
        }

        // todo  这里获取当前userList的select 的内容

        // 删除操作
        ElMessageBox.confirm(
          `将（${queryForm.create_user_name}）~（${queryForm.daily_date}）日志设为未确认, 是否继续?`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          },
        )
          .then(async () => {
            const info = { daily_date: queryForm.daily_date, create_user_id: queryForm.create_user_id }
            debugger

            // let res =await projectDaily.confirmBatchProjectDaily(info)
            const res = await projectDaily.unConfrimBatch(info)

            debugger
            if (res.code < window.MAX_SUCCESS_CODE) {
              getDiaryPage()
              ElMessage.success(`${res.message}`)
            }
          })
          .catch(() => {
            // 用户点击取消按钮时执行的操作
            // 可以选择不做任何事情，也可以显示取消消息
            // ElMessage.info('操作已取消'); // 如果需要显示取消消息，可以取消注释
          })
      } catch (error) {
        if (error.code === 10020) {
          ElMessage.error('请填写确认有提交日志')
        }
      }
    }

    /**
     * 日志颜色区分
     */
    const rowClassName = ({ row }) => {
      if (row.supplementary_flag === 1) {
        return 'supplementary-row'
      }
      return 'no-supplementary-row'
    }

    return {
      loading,

      projectInfoArr,
      dailyTypeArr,
      dailyStatusArr,
      dailyCommitArr,
      dailyConfirmArr,
      userList,

      queryForm,
      tableData,
      search,
      handleEdit,
      handleDelete,
      handleCommit,
      handleConfirm,
      handleConfirm2,
      handleUnConfirm,

      indexMethod,
      currentPage,
      pageSize,
      totalSize,

      handleSizeChange,
      handleCurrentChange,

      // 日志部分
      editDiaryId,
      editClose,
      add,
      addBatch,
      showEdit,
      formatDate,

      // 日志的确认
      handlerConfirmBatch,
      handlerConfirmBatch2,
      handlerUnConfirmBatch,
      handleUserChange,
      rowClassName,

      dialogConfirm,
      formLabelWidth,
      confirmForm,

      handlerConfirmCancel,
      handlerConfirm,
      handlerConfirmNo,
    }
  },
}

function getDefaultDate() {
  const today = new Date()
  const year = today.getFullYear()
  const month = String(today.getMonth() + 1).padStart(2, '0')
  const day = String(today.getDate()).padStart(2, '0')
  const now = `${year}-${month}-${day}`
  return now
}
</script>

<style scoped>
.demo-form-inline .el-input {
  --el-input-width: 220px;
}

.page-container {
  padding: 10px;
}

.search-section {
  margin-bottom: 10px;
  padding: 20px;
  /* background-color: #f5f5f5; */
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.table-section {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.demo-pagination-block {
  margin-top: 10px;
}
.demo-pagination-block .demonstration {
  margin-bottom: 16px;
}
</style>

<style>
.supplementary-row {
  background-color: rgb(215, 218, 50) !important;
  width: 100%;
}

.no-supplementary-row {
  background-color: #f8f9fa !important;
}

.el-form-item {
  width: 220px;
}
</style>
